export const ballDiameterInches = 2.9
export const ballRadiusInches = ballDiameterInches / 2
export const ballRadiusFeet = ballRadiusInches / 12
